import React from 'react';
import { Stack, Text } from 'library/ui';
import LogoRow from './LogoRow';
import { useUserContext } from 'UserContext';
import { styled } from '@mui/material';
import { Colors } from 'library';
import DownloadTheAppButtons from '../../public/shared/components/DownloadTheAppButtons';

export default function Footer() {
    const { user } = useUserContext();

    const welcomeText = 'The platform for the modern care industry';

    return !user ? (
        <FooterContainer gap="sm" justify="between" padding="sm">
            <Stack gap="sm" align="center">
                <Text tone="overlay" size="xl" weight="bold">
                    Join Tandem
                </Text>
                <Text tone="overlay" size="lg">
                    {welcomeText}
                </Text>
            </Stack>
            <Stack gap="lg" align="center" padding="lg">
                <LogoRow />
                <DownloadTheAppButtons />
            </Stack>
        </FooterContainer>
    ) : null;
}

const FooterContainer = styled(Stack)({
    backgroundColor: Colors.primary,
});
